/* Bella K Relaunch (bkr): gemeinsame Helfer für alle bkr-Sections.
   window.bkr.section(selector, init): ruft init(root) für jede Section auf, beim Laden
   und erneut, wenn der Theme-Editor eine Section neu rendert (shopify:section:load).
   init darf eine Aufräumfunktion zurückgeben, die bei shopify:section:unload läuft. */
(function () {
  if (window.bkr) return;
  var d = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var registry = [];
  var cleanups = new WeakMap();

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  function run(entry, scope) {
    $$(entry.sel, scope).forEach(function (root) {
      if (root.__bkrInit && root.__bkrInit.indexOf(entry.sel) > -1) return;
      (root.__bkrInit = root.__bkrInit || []).push(entry.sel);
      var undo = entry.init(root);
      if (typeof undo === 'function') cleanups.set(root, (cleanups.get(root) || []).concat(undo));
    });
  }

  function section(sel, init) {
    var entry = { sel: sel, init: init };
    registry.push(entry);
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { run(entry); });
    else run(entry);
  }

  d.addEventListener('shopify:section:load', function (ev) {
    registry.forEach(function (entry) { run(entry, ev.target); });
    reveal(ev.target);
  });
  d.addEventListener('shopify:section:unload', function (ev) {
    $$('*', ev.target).concat([ev.target]).forEach(function (el) {
      (cleanups.get(el) || []).forEach(function (fn) { try { fn(); } catch (e) {} });
    });
  });

  /* Sticky-Header-Höhe für Offsets (sticky Kaufleiste, Pin der Erklärung, Anker) */
  function measureTop() {
    var h = 0;
    var header = $('.shopify-section-header-sticky, .section-header.shopify-section-header-sticky');
    if (header) h += header.getBoundingClientRect().height;
    d.documentElement.style.setProperty('--bkr-top', Math.round(h) + 'px');
  }
  window.addEventListener('resize', measureTop);
  d.addEventListener('DOMContentLoaded', measureTop);

  /* Reveal beim Scrollen */
  var io = (!reduce && !design && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.filter(function (x) { return x.isIntersecting; }).forEach(function (x, i) {
      x.target.style.setProperty('--rd', (i * 0.08) + 's');
      x.target.classList.add('is-in');
      io.unobserve(x.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
  function reveal(scope) {
    $$('.bkr [data-reveal]', scope).concat(scope && scope.matches && scope.matches('.bkr [data-reveal]') ? [scope] : []).forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { reveal(); });
  else reveal();

  window.bkr = { section: section, $: $, $$: $$, reduce: reduce, design: design };
})();
